import { render, staticRenderFns } from "./PProductsPicker.vue?vue&type=template&id=61678120"
import script from "./PProductsPicker.vue?vue&type=script&lang=js"
export * from "./PProductsPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports